import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type ListExportTasksParams } from '@webapp/modules/reports/business-logic/interfaces/IReportExportTaskRepository'
import { reportExportTaskRepository } from '@webapp/modules/reports/data-access/repositories/ReportExportTaskRepository'

const base = ['export-task']

// Invalidated by create-report-export (2.1) and delete-export-task (2.4).
export const EXPORT_TASK_BASE_KEY = buildQueryKey([...base])

// ADR-5 query configs for /api/v3/export-tasks/. Cluster 2.1 creates
// `list` + `progress`; cluster 2.4 (Export History) reuses `list`.
export const exportTaskQueries = {
  list: (params: ListExportTasksParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => reportExportTaskRepository.list(params),
  }),

  // The key intentionally contains ONLY taskId: `listParams` (type filter +
  // date window) are key-invariant constants derived once from the seeded
  // task for the lifetime of the progress modal.
  progress: (taskId: number, listParams: ListExportTasksParams) => ({
    queryKey: buildQueryKey([...base, 'progress', taskId]),
    queryFn: async () => {
      const result = await reportExportTaskRepository.list(listParams)
      const task = result.items.find((item) => item.id === taskId)

      if (!task) {
        // Rejecting keeps the previously fetched data (and the polling
        // interval) alive instead of clearing the progress content.
        throw new Error(`Export task ${taskId} was not found`)
      }

      return task
    },
  }),
}
